module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/61fe52be6a05d9e91eba82c754fe6c05.png";